function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { EdgeDetection } from 'xps-react-utils';
import isUnstable from '../utils/isUnstable';

var MenuPanel = function MenuPanel(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      height = _ref.height,
      isOpen = _ref.isOpen,
      _ref$triggerSize = _ref.triggerSize,
      triggerSize = _ref$triggerSize === void 0 ? 'small' : _ref$triggerSize,
      width = _ref.width;
  isUnstable('MenuPanel');
  var panelRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isUpward = _useState2[0],
      setIsUpward = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isAlignedRight = _useState4[0],
      setIsAlignedRight = _useState4[1];

  var menuPanelClasses = cx((_cx = {}, _defineProperty(_cx, "bottom-".concat(triggerSize), isUpward), _defineProperty(_cx, "dropdown__panel", true), _defineProperty(_cx, 'display-block', isOpen), _defineProperty(_cx, 'display-none', !isOpen), _defineProperty(_cx, 'dropdown__panel--right', isAlignedRight), _defineProperty(_cx, 'overflowy-auto', true), _cx), className); // Once the useRef hook has gained a reference node, it will apply the height and width props.

  if (panelRef !== null && panelRef.current !== null) {
    panelRef.current.style.height = "".concat(height, "px");
    panelRef.current.style.width = "".concat(width, "px");
  }

  useEffect(function () {
    // First, we check for overflows.
    var ofCheck = EdgeDetection.detect(EdgeDetection.getDimensions(panelRef.current), EdgeDetection.getWindowDimensions()); // Then, we extract the overflow directions for easy reference.

    var ofDirections = ofCheck.map(function (of) {
      return of.direction;
    }); // Based on the overflows, we realign the MenuPanel component.

    if (ofDirections.includes('bottom') && ofDirections.includes('right')) {
      setIsAlignedRight(true);
      setIsUpward(true);
    } else if (ofDirections.includes('bottom') && !ofDirections.includes('right')) {
      setIsUpward(true);
      setIsAlignedRight(false);
    } else if (!ofDirections.includes('bottom') && ofDirections.includes('right')) {
      setIsUpward(false);
      setIsAlignedRight(true);
    } else {
      setIsUpward(false);
      setIsAlignedRight(false);
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("div", {
    className: menuPanelClasses,
    ref: panelRef
  }, children);
};

MenuPanel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.number,
  isOpen: PropTypes.bool,
  triggerSize: PropTypes.oneOf(['large', 'medium', 'small']),
  width: PropTypes.number
};
MenuPanel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MenuPanel",
  "props": {
    "triggerSize": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'large'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "height": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "isOpen": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};
export default MenuPanel;